import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import { CLEAN_VIDEO_SUBTITLE_LANGUAGE_ID } from "../../../../../common/api/master-api/common/consts";
import { useDubbings } from "../../../../../common/data/data-hooks/useDubbings";
import { useDynamicSubtitles } from "../../../../../common/data/data-hooks/useDynamicSubtitles";
import { useEmbeddedSubtitles } from "../../../../../common/data/data-hooks/useEmbeddedSubtitles";
import { useLanguages } from "../../../../../common/data/data-hooks/useLanguages";
import { getOrderDashboardHref, orderListingRoute } from "../../../../OrdersRoutes";
import { useDeliveryEndpoints } from "./useDeliveryEndpoints";
import { useEncodeSpecifications } from "./useEncodeSpecifications";
import { useLoadOrderForm } from "./useLoadOrderForm";
import { useOrderAirlines } from "./useOrderAirlines";
import { useSystems } from "./useSystems";

export interface CreateOrderFormInputs {
    contentId: string;
    contentSeasonId?: string;
    contentEpisodeId?: string;
    contentVersionId: string;
    airlineId: string;
    systemId: string;
    encodeSpecificationId: string;
    targetResolutionId?: string;
    soundtrackIds: string[];
    dynamicSubtitlesIds: string[];
    embeddedSubtitlesId: string;
    dueDate: Date;
    deliveryFolder?: string;
    targetFileName: string;
    subtitlesTargetFileName?: string;
    pONumber: string;
    startDate: Date;
    isSubtitlesEmbedded: boolean;
}

export const useCreateOrderForm = () => {
    const { isLoading: areAirlinesLoading } = useOrderAirlines();
    const { isLoading: areDubbingsLoading } = useDubbings();
    const { isLoading: areLanguagesLoading } = useLanguages();
    const { isLoading: areEmbeddedSubtitlesLoading } = useEmbeddedSubtitles();
    const { isLoading: areDynamicSubtitlesLoading } = useDynamicSubtitles();
    const { isLoading: areSystemsLoading } = useSystems();
    const { isLoading: areDeliveryEndpointsLoading } = useDeliveryEndpoints();
    const { isLoading: areEncodeSpecificationsLoading } = useEncodeSpecifications();

    const history = useHistory();

    const goToOrderListing = () => {
        history.push(orderListingRoute.path);
    };

    const goToOrderDetails = (orderId: string) => {
        history.push(getOrderDashboardHref(orderId));
    };

    const form = useForm<CreateOrderFormInputs>({
        defaultValues: {
            contentId: "",
            contentSeasonId: undefined,
            contentEpisodeId: undefined,
            contentVersionId: "",
            airlineId: "",
            systemId: "",
            encodeSpecificationId: "",
            soundtrackIds: [],
            embeddedSubtitlesId: CLEAN_VIDEO_SUBTITLE_LANGUAGE_ID,
            dueDate: new Date(),
            dynamicSubtitlesIds: [],
            deliveryFolder: "",
            targetFileName: "",
            subtitlesTargetFileName: "",
            pONumber: "",
            startDate: new Date(),
            isSubtitlesEmbedded: false,
            targetResolutionId: ""
        },
        criteriaMode: "all"
    });

    const { sourceOrder } = useLoadOrderForm(form);

    const isLoading =
        areAirlinesLoading ||
        areLanguagesLoading ||
        areDubbingsLoading ||
        areEmbeddedSubtitlesLoading ||
        areDynamicSubtitlesLoading ||
        areSystemsLoading ||
        areDeliveryEndpointsLoading ||
        areEncodeSpecificationsLoading;

    return {
        form,
        isLoading,
        goToOrderListing,
        goToOrderDetails,
        sourceOrder
    };
};
